module.exports = __webpack_public_path__ + "static/media/qingming5Bg.ae44bb83.jpg";